{
  "nav": {
    "overview": "Overview",
    "servers": "Servers",
    "billing": "Billing",
    "ai-credits": "AI credits",
    "team": "Team",
    "support": "Support",
    "releases": "Releases",
    "settings": "Settings",
    "groups": {
      "account": "Account"
    }
  },
  "a11y": {
    "mainNav": "Main navigation",
    "home": "bPanel, overview",
    "skip": "Skip to content",
    "openMenu": "Open menu",
    "collapseSidebar": "Collapse sidebar",
    "expandSidebar": "Expand sidebar"
  },
  "help": {
    "docs": "Docs",
    "status": "Service status"
  },
  "mock": {
    "badge": "Demo data",
    "reset": "Reset demo data",
    "resetTitle": "Reset the demo data?",
    "resetBody": "Every demo account, server and invoice goes back to its starting state, and you are signed out.",
    "resetConfirm": "Reset",
    "resetDone": "The demo data is back to its starting state."
  },
  "language": {
    "other": "العربية",
    "switchTo": "التبديل إلى العربية"
  },
  "org": {
    "switch": "Switch company",
    "title": "Your companies"
  },
  "notifications": {
    "label": "Notifications",
    "labelUnread_one": "Notifications, 1 new",
    "labelUnread_other": "Notifications, {{count}} new",
    "title": "Notifications",
    "markAll": "Mark all as read",
    "empty": "You have no notifications",
    "viewAll": "View all notifications"
  },
  "user": {
    "menu": "Account menu",
    "profile": "Profile",
    "settings": "Settings",
    "signOut": "Sign out"
  },
  "command": {
    "title": "Search",
    "trigger": "Search or jump to...",
    "placeholder": "Type a page, a server or an action",
    "empty": "No results",
    "groups": {
      "pages": "Pages",
      "servers": "Servers",
      "actions": "Actions"
    },
    "actions": {
      "addServer": "Add a server",
      "activate": "Activate a server with a code"
    }
  },
  "banners": {
    "dunning": {
      "title": "A renewal payment didn't go through.",
      "amount": "Amount due",
      "failedOn": "since {{date}}.",
      "body": "Your servers run normally during the payment grace period. After that, the control panel locks until you pay.",
      "action": "Pay now"
    },
    "trial": {
      "title_one": "1 day left in your free trial.",
      "title_other": "{{count}} days left in your free trial.",
      "noCard": "Set up payment so your servers keep running without a break.",
      "withCard": "Payment is set up. Your subscription starts automatically on {{date}}.",
      "action": "Set up payment"
    },
    "grace": {
      "title": "{{server}} can't reach bPanel.",
      "until": "Websites run as usual. If it doesn't connect by {{date}}, adding new accounts stops.",
      "body": "Websites run as usual, but adding new accounts stops if it stays offline.",
      "action": "View server"
    },
    "locked": {
      "title": "The control panel on {{server}} is locked.",
      "body": "The subscription has ended. Websites and mail keep running, and nothing is deleted.",
      "action": "Renew now"
    }
  },
  "focus": {
    "exit": "Back to dashboard"
  }
}
